import { Routes } from '@angular/router';
import { ownerPortalGuard } from './core/services/owner-portal.guard';
import { OwnerShell } from './shell/owner-shell/owner-shell';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/owner-login').then((m) => m.OwnerLogin),
  },
  {
    path: '',
    component: OwnerShell,
    canActivate: [ownerPortalGuard],
    canActivateChild: [ownerPortalGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/owner-dashboard').then((m) => m.OwnerDashboard),
      },
      {
        path: 'properties',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Properties', subtitle: 'Assigned properties and occupancy details.' },
      },
      {
        path: 'financials',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Financials', subtitle: 'Cash flow, fees, expenses, reserves, and payout impact.' },
      },
      {
        path: 'statements',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Statements', subtitle: 'Published owner packets and monthly payout records.' },
      },
      {
        path: 'tax-documents',
        loadComponent: () => import('./pages/tax-documents/owner-tax-documents').then((m) => m.OwnerTaxDocuments),
      },
      {
        path: 'transactions',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Transactions', subtitle: 'Income, expenses, fees, and payout records.' },
      },
      {
        path: 'maintenance',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Maintenance', subtitle: 'Work orders, cost approvals, vendor updates, and SLA risk.' },
      },
      {
        path: 'inspections',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Inspections', subtitle: 'Condition reports, inspection history, photos, and follow-up items.' },
      },
      {
        path: 'documents',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Documents', subtitle: 'Owner statements, agreements, reports, and shared files.' },
      },
      {
        path: 'approvals',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Approvals', subtitle: 'Repair estimates, reserve draws, lease decisions, and capital work.' },
      },
      {
        path: 'messages',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Updates', subtitle: 'Notifications, requests, and portfolio notices shared by your property team.' },
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Reports', subtitle: 'Portfolio reports generated by your property team.' },
      },
      {
        path: 'audit-trail',
        loadComponent: () => import('./pages/audit-trail/owner-audit-trail').then((m) => m.OwnerAuditTrail),
      },
      {
        path: 'communications',
        loadComponent: () => import('./pages/communications/owner-communications').then((m) => m.OwnerCommunications),
      },
      {
        path: 'support',
        loadComponent: () => import('./pages/support/owner-support').then((m) => m.OwnerSupport),
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/section/owner-section').then((m) => m.OwnerSection),
        data: { title: 'Settings', subtitle: 'Profile and notification preferences.' },
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
